var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"StatusCell"}},[(_vm.currentStatus)?_c('span',{class:_vm.currentStatus.color},[(_vm.currentStatus.icon)?_c('i',{staticClass:"status-icon",class:_vm.currentStatus.icon,style:(_vm.currentStatus.iconStyle)}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.currentStatus.text))])]):_c('span',[_vm._v(_vm._s(_vm.emptyText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }